import { Type } from 'class-transformer'
import { ExamElementKind } from '@/types/exam-element'

export class ExerciseAnswer {
    public exerciseNr : number
    public kind: ExamElementKind
    public text?: String
    public code?: String
    public svg?: String
    public selectedAnswer?: String
    public selectedAnswers?: String[]

    constructor (
      exerciseNr : number = 0,
      kind: ExamElementKind,
      text = '',
      code = '',
      svg = '',
      selectedAnswer = '',
      selectedAnswers = []) {
      this.exerciseNr = exerciseNr
      this.kind = kind
      this.text = text
      this.code = code
      this.svg = svg
      this.selectedAnswer = selectedAnswer
      this.selectedAnswers = selectedAnswers
    }
}

export class Submission {
    public matNr: string;
    public studentName: string;
    public skz?: string;
    public firstName?: string;
    public lastName?: string;
    public code: string;
    public examKey: string;
    @Type(() => ExerciseAnswer)
    public exerciseAnswers: ExerciseAnswer[]

    constructor (
      matNr: string = '',
      studentName: string = '',
      skz: string = '',
      firstName : string = '',
      lastName: string = '',
      code: string = '',
      examKey: string = '',
      exerciseAnswers: ExerciseAnswer[] = []) {
      this.matNr = matNr
      this.studentName = studentName
      this.skz = skz
      this.firstName = firstName
      this.lastName = lastName
      this.code = code
      this.examKey = examKey
      this.exerciseAnswers = exerciseAnswers
    }
}
